import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { getIn, setIn } from 'formik';
import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PricingErrorContext } from '../../PricingErrorContext';
import './Pricing.scss';
import CostInfo from './CostInfo';
import PriceDiscount from './PriceDiscount';
import { ReactComponent as ClassNoData } from 'assets/icons/no-data-class-icon.svg';
import InternalDrawer from '../ClassInformation/InternalDrawer';

const Pricing = (props) => {
  const { pricingErrors, pricingTouched, setPricingErrors, setPricingTouched } = useContext(PricingErrorContext);


  const clearFieldError = (name) => {
    if (!pricingErrors || Object.keys(pricingErrors).length === 0) return;
    if (getIn(pricingErrors, name) === undefined) return;
    setPricingErrors((prev) => setIn(prev, name, undefined));
    setPricingTouched((prev) => setIn(prev, name, undefined));
  };

  const wrappedSetFieldValue = (name, value, shouldValidate) => {
    clearFieldError(name);
    return props.setFieldValue(name, value, shouldValidate);
  };

  const setFieldError = (name, error) => {
    setPricingErrors((prev) => setIn(prev || {}, name, error));
  };

  const setFieldTouched = (name, touched = true) => {
    setPricingTouched((prev) => setIn(prev || {}, name, touched));
  };

  const formik = {
    ...props,
    setFieldValue: wrappedSetFieldValue,
    setFieldError,
    setFieldTouched,
    errors: (pricingErrors && Object.keys(pricingErrors).length > 0) ? pricingErrors : props.errors,
    touched: (pricingTouched && Object.keys(pricingTouched).length > 0) ? pricingTouched : props.touched,
  };

  const hasCostInfoErrors = !!(
    Array.isArray(formik.errors?.prices) &&
    formik.errors.prices.some((e) => e && Object.keys(e).length > 0)
  );

  const hasDiscountErrors = !!(
    Array.isArray(formik.errors?.discount) &&
    formik.errors.discount.some((e) => e && Object.keys(e).length > 0)
  );

  return (
    <div className="class_info_container">
      <div className="left_section">
        <div className="left_content">
          <div className="info_title">
            <h2>Pricing Information</h2>
            <p>Please complete the details below</p>
          </div>
          <div className="class__tabs">
            <p
              className={formik.values?.step2Active === 'costInfo' ? 'active' : 'inactive'}
              onClick={() => formik.setFieldValue("step2Active", 'costInfo')}
            >
              Cost Info
              {hasCostInfoErrors && (
                <ErrorOutlineIcon style={{ color: "#dc3545", fontSize: 18, marginLeft: 4 }} />
              )}
            </p>
            <p
              className={formik.values?.step2Active === 'priceDiscount' ? 'active' : 'inactive'}
              onClick={() => formik.setFieldValue("step2Active", 'priceDiscount')}
            >
              Discount
              {hasDiscountErrors && (
                <ErrorOutlineIcon style={{ color: "#dc3545", fontSize: 18, marginLeft: 4 }} />
              )}
            </p>
          </div>
          <div className="classTap_content">
            {formik.values?.step2Active === 'costInfo' ? (
              <CostInfo formik={formik} />
            ) : (
              <PriceDiscount
                formik={formik}
                expandedIndex={formik.values?.discountExpandedIndex ?? -1}
                setExpandedIndex={(i) => formik.setFieldValue('discountExpandedIndex', i)}
              />
            )}
          </div>
        </div>
      </div>
      <div className="right_sectoin">
        <InternalDrawer formik={formik}/>
      </div>
    </div>
  );
};

export default Pricing;
